<h2 mat-dialog-title class="edit-references-title">References for this embedding</h2>

<mat-dialog-content class="edit-references-dialog-content">
  <div class="chunk-context" role="region" aria-label="Embedding content preview">
    <mat-icon class="chunk-context__icon" aria-hidden="true">format_quote</mat-icon>
    <p class="chunk-context__text" [matTooltip]="data.embedding.content" matTooltipShowDelay="400">
      {{ previewSnippet }}
    </p>
  </div>

  <app-source-references
    class="edit-references-embed"
    [sourceItem]="data.source"
    [sourceEmbedding]="data.embedding"
    [layout]="'dialog'"
  >
  </app-source-references>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-flat-button color="primary" type="button" (click)="cancel()">Done</button>
</mat-dialog-actions>
